import { FA } from '@/components/common/icons/FA';
import { FEATURES } from '@/config/features';
import { getColor } from '@/helpers/utils';
import { CustomIconFC } from '@/types/shared';

export const CustomerIcon: CustomIconFC = (props) => (
  <FA icon={FEATURES.Customer.icon} theme="far" color={getColor('customer')} {...props} />
);
